<template>
  <!-- <el-tooltip> -->
  <!-- <transition slot="content" name="fade" mode="out-in">
      <div v-if="!barConfig.noTooltip" class="g-gantt-tooltip">
        <div class="color-indicator" :style="{ background: this.barStyle.background || this.barStyle.backgroundColor }" />
        {{ bar[barStart] | TimeFilter }}
        -
        {{ bar[barEnd] | TimeFilter }}
      </div>
  </transition>-->
  <el-popover
    :ref="`popover-${barid}`"
    placement="left-start"
    width="400"
    trigger="manual"
    v-model="showTip"
  >
    <div class="pl pr text-black">
      <div class="pull-right font-16">{{ bar.station_title }}</div>
      <!-- <div class="text-muted">{{ bar.label }}</div> -->
      <div class="text-muted flex">
        {{ bar.label }}
        <el-tooltip content="主工单" placement="top" v-if="bar.type == 1" >
          <icon-svg icon-class="maintask" style="font-size: 22px"/>
        </el-tooltip>
        <el-tooltip content="子工单" placement="top" v-else-if="bar.type == 2">
          <icon-svg icon-class="subtask" style="font-size: 22px"/>
        </el-tooltip>
      </div>

      <div class="font-20">{{ bar.process_title }}</div>
      <div class="pt pb process">
        <div class="flex justify-content-space-between font-12">
          <span v-if="bar.status <= 20" class="text-muted">计划开工</span>
          <span v-else>开工时间</span>
          <span v-if="bar.status == 20" class="text-blue">待开工</span>
          <span v-if="bar.status == 30" class="text-success">加工中</span>
          <span v-if="bar.status >= 80">已完工</span>
          <span v-if="bar.status < 80" class="text-muted">计划完工</span>
          <span v-else>完工时间</span>
        </div>
        <el-progress v-if="bar.status <= 20" :percentage="0" :show-text="false" color="#409EFF"></el-progress>

        <el-progress
          v-if="bar.status == 30"
          :percentage="bar.percentage ? bar.percentage : 5"
          :show-text="false"
        ></el-progress>

        <el-progress v-if="bar.status >= 80" :percentage="100" :show-text="false" color="#06793d"></el-progress>

        <div class="flex justify-content-space-between font-12">
          <span v-if="bar.status <= 20" class="text-muted">
            {{
            bar.plan_starttime | parseTime("{y}-{m}-{d} {h}:{i}")
            }}
          </span>
          <span v-else>
            {{
            bar.starttime | parseTime("{y}-{m}-{d} {h}:{i}")
            }}
          </span>

          <span v-if="bar.status == 30" class="text-success">已用时 {{ bar.total_used }}</span>

          <span
            v-if="bar.status <= 20 || bar.status == 30"
            class="text-muted"
          >{{ bar.plan_endtime | parseTime("{y}-{m}-{d} {h}:{i}") }}</span>
          <span v-if="bar.status >= 80">
            {{
            bar.endtime | parseTime("{y}-{m}-{d} {h}:{i}")
            }}
          </span>
        </div>
      </div>
      <div class="pb pt">
        <div class="pt-sm flex" v-if="bar.mfg_no">
          <div class="d-title">制号</div>：
          <div></div>
          {{ bar.mfg_no }}
        </div>
        <div class="pt-sm flex" v-if="bar.material_no">
          <div class="d-title">部件</div>：
          <div></div>
          {{ bar.material_no + " / " + bar.material_title }}
        </div>
        <div class="pt-sm flex" v-if="bar.process_no">
          <div class="d-title">工序</div>：
          <div></div>
          {{ bar.process_no + " / " + bar.process_title }}
        </div>
        <div class="pt-sm flex" v-if="bar.plan_num">
          <div class="d-title">数量</div>：
          <div></div>
          <span class="tag mr-xs font-10">派工</span>
          {{ bar.plan_num }} 件
        </div>
        <div class="pt-sm flex" v-if="bar.standard_hour">
          <div class="d-title">工时</div>：
          <div></div>
          <span class="tag mr-xs font-10">派工</span>
          {{ bar.standard_hour + " " + bar.standard_unit + " /件" }}
          <span
            class="tag ml-xs mr-xs font-10"
            v-if="bar.add_hour"
          >附加</span>
          <span v-if="bar.add_hour">
            {{
            bar.add_hour + " " + bar.standard_unit
            }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="g-gantt-bar"
      :id="'bar' + bar.id"
      ref="g-gantt-bar"
      :style="barStyle"
      slot="reference"
      @mouseenter.stop="onMouseenter($event)"
      @mouseleave.stop="onMouseleave($event)"
      @mousedown.stop="onMousedown($event)"
      @click.stop="onClick($event)"
      @dblclick="onDblclick($event)"
      @contextmenu="onContextmenu($event)"
    >
      <div :class="[barConfig.highlight&&'highlight']"></div>
      <div v-if="bar.status >= 30" :style="barInner" class="gantt-bar-inner"></div>
      <i v-if="bar.status >= 30" class="el-icon-lock font-20 text-muted ml" style="z-index: 1" />
      <div class="g-gantt-bar-label">
        <span class="show-label">
          {{
          bar.workorder_no +
          (bar.material_title ? " / " + bar.material_title : "") || ""
          }}
        </span>
      </div>
      <template v-if="allowDrag">
        <div v-if="bar.status < 30" class="g-gantt-bar-handle-left" />
        <div class="g-gantt-bar-handle-right" />
      </template>
    </div>
  </el-popover>
</template>

<script>
import moment from "moment";
import Vue from "vue";
export default {
  name: "GGanttBar",

  props: {
    bar: { type: Object },
    barStart: { type: String }, // property name of the bar objects that represents the start datetime
    barEnd: { type: String }, // property name of the bar objects that represents the end datetime,
    barContainer: [Object, DOMRect],
    allBarsInRow: { type: Array },
    rowcount: Number,
    rowN: Number,
    activeid: {
      type: [Number, null],
    },
  },

  inject: [
    "getHourCount",
    "ganttChartProps",
    "initDragOfBarsFromBundle",
    "moveBarsFromBundleOfPushedBar",
    "setDragLimitsOfGanttBar",
    "onBarEvent",
    "onDragendBar",
    "getMinGapBetweenBars",
  ],

  data() {
    return {
      // showTooltip: false,
      tooltipTimeout: null,
      dragLimitLeft: null,
      dragLimitRight: null,
      isDragging: false,
      isMainBarOfDrag: false, // is this the bar that was clicked on when starting to drag
      // or is it dragged along some other bar from the same bundle
      cursorOffsetX: 0,
      cursorOffsetY: 0,
      mousemoveCallback: null, // gets initialized when starting to drag
      // possible values: drag, dragByHandleLeft, dragByHandleRight,
      barStartBeforeDrag: null,
      barEndBeforeDrag: null,
      newYStart: null,
      barid: this.bar.id,
      sss: null,
      eee: null,
      showTip: false,
    };
  },

  computed: {
    allowDrag() {
      return (
        this.barConfig.handles &&
        Number(this.barStyle.width.replace("px", "")) > 15
      );
    },

    // barStartMoment: {
    //   get() {
    //     return moment(this.bar[this.barStart]);
    //   },
    //   set(value) {
    //     this.bar[this.barStart] = moment(value).format("YYYY-MM-DD HH:mm:ss");
    //   },
    // },

    // barEndMoment: {
    //   get() {
    //     return moment(this.bar[this.barEnd]);
    //   },
    //   set(value) {
    //     this.bar[this.barEnd] = moment(value).format("YYYY-MM-DD HH:mm:ss");
    //   },
    // },
    // use these computed moment objects to work with the bar's start/end dates:
    // instead of directly mutating them:
    barStartMoment: {
      get() {
        // this.bar[this.barStart] = this.bar[this.barStart]
        // this.sss = moment(this.bar[this.barStart]);
        // return this.sss;
        return moment(this.bar[this.barStart]);
      },
      set(value) {
        this.bar[this.barStart] = moment(value).format("YYYY-MM-DD HH:mm:ss");
        // Vue.set(
        // 	this.bar,
        // 	this.barStart,
        // 	moment(value).format("YYYY-MM-DD HH:mm:ss")
        // );
        // this.sss = moment(this.bar[this.barStart]);
      },
    },

    barEndMoment: {
      get() {
        this.eee = moment(this.bar[this.barEnd]);
        return this.eee;
      },
      set(value) {
        Vue.set(
          this.bar,
          this.barEnd,
          moment(value).format("YYYY-MM-DD HH:mm:ss")
        );
        this.eee = moment(this.bar[this.barEnd]);
      },
    },

    barConfig() {
      if (this.bar.ganttBarConfig) {
        return {
          ...this.bar.ganttBarConfig,
          display: this.bar.ganttBarConfig.display || "flex",
          background: this.bar.ganttBarConfig.isShadow
            ? "grey"
            : this.bar.ganttBarConfig.background ||
              this.bar.ganttBarConfig.backgroundColor,
          opacity: this.bar.ganttBarConfig.isShadow
            ? "0.3"
            : this.bar.ganttBarConfig.opacity,
          highlight: this.bar.ganttBarConfig.highlight ? true : false,
        };
      }
      return {};
    },

    barInner() {
      let xStart = this.mapTimeToPosition(moment(this.bar.starttime * 1000));
      let xEnd = this.mapTimeToPosition(moment(new Date()));
      let xinitStart = this.mapTimeToPosition(this.barStartMoment);
      let xinitEnd = this.mapTimeToPosition(this.barEndMoment);
      let width = xEnd - xStart;
      let width2 = (xinitEnd - xinitStart) * 0.95;
      if (width > width2) {
        width = width2;
      }
      let per = 0;
      if (this.bar.status >= 30) {
        per = 1;
      } else if (this.bar.status <= 20) {
        per = 0;
      }
      return {
        position: "absolute",
        width: width * per + "px",
        background: "#07C160",
        height: this.barConfig.highlight ? "24px" : "28px",
        borderRadius: "15px",
      };
    },

    barStyle() {
      let xStart = this.mapTimeToPosition(this.barStartMoment);
      let xEnd = this.mapTimeToPosition(this.barEndMoment);
      if (this.barid === this.bar.id) {
        return {
          ...(this.barConfig || {}),
          border: this.bar.status == 0 ? "1px dashed #997BEC" : "",
          left: `${xStart}px`,
          top: `${this.newYStart}px`,
          width: `${xEnd - xStart}px`,
          height: `${this.ganttChartProps.rowHeight - 12}px`,
          zIndex: !this.barConfig.highlight
            ? this.barConfig.zIndex || (this.isDragging ? 2 : 1)
            : 2,
        };
      } else {
        this.barid = this.bar.id;
        this.newYStart = null;
        return {
          ...(this.barConfig || {}),
          border: this.bar.status == 0 ? "1px dashed #997BEC" : "",
          left: `${xStart}px`,
          width: `${xEnd - xStart}px`,
          height: `${this.ganttChartProps.rowHeight - 12}px`,
          zIndex: !this.barConfig.highlight
            ? this.barConfig.zIndex || (this.isDragging ? 2 : 1)
            : 2,
        };
      }
    },

    showToolTip: {
      get() {
        return this.activeid == this.barid;
      },
      set() {},
    },

    chartStartMoment() {
      return moment(this.ganttChartProps.chartStart);
    },

    chartEndMoment() {
      return moment(this.ganttChartProps.chartEnd);
    },
  },

  created() {
    this.initTop = this.barContainer.top;
    // this.bar.row = this.rowN + 1
  },

  mounted() {
    this.showTip = this.showToolTip;
  },

  updated() {
    this.showTip = this.showToolTip;
  },

  methods: {
    onMouseenter(e) {
      // if (this.tooltipTimeout) {
      //   clearTimeout(this.tooltipTimeout)
      // }
      // this.tooltipTimeout = setTimeout(() => (this.showTooltip = true), 800)
      // this.onBarEvent({ event: e, type: e.type }, this)
    },

    onMouseleave(e) {
      // clearTimeout(this.tooltipTimeout)
      // this.showTooltip = false
      // this.onBarEvent({ event: e, type: e.type }, this)
    },

    onContextmenu(e) {
      // const time = this.mapPositionToTime(e.clientX - this.barContainer.left).format('YYYY-MM-DD HH:mm:ss')
      // this.onBarEvent({ event: e, type: e.type, time }, this)
    },

    onClick(e) {
      if (this.activeid != this.barid) {
        this.$emit("closePopover", this.barid);
      } else {
        this.$emit("closePopover", null);
      }

      // const time = this.mapPositionToTime(e.clientX - this.barContainer.left).format('YYYY-MM-DD HH:mm:ss')
      // this.onBarEvent({ event: e, type: e.type, time }, this)
    },

    onDblclick(e) {
      e.preventDefault();
      this.$detail(this.bar.workorderid);

      // const time = this.mapPositionToTime(e.clientX - this.barContainer.left).format('YYYY-MM-DD HH:mm:ss')
      // this.onBarEvent({ event: e, type: e.type, time }, this)
    },

    onMousedown(e) {
      // this.$emit('closePopover', null)
      e.preventDefault();
      if (e.button === 2) {
        return;
      }

      this.$parent.refreshClient();
      if (!this.barConfig.immobile && !this.barConfig.isShadow) {
        this.setDragLimitsOfGanttBar(this);
        // initialize the dragging on next mousemove event:
        window.addEventListener("mousemove", this.onFirstMousemove, {
          once: true,
        });
        // if next mousemove happens after mouse up (if user just presses mouse button down, then up, without moving):
        window.addEventListener(
          "mouseup",
          () => window.removeEventListener("mousemove", this.onFirstMousemove),
          { once: true }
        );
      }
      const time = this.mapPositionToTime(
        e.clientX - this.barContainer.left
      ).format("YYYY-MM-DD HH:mm:ss");
      this.onBarEvent({ event: e, type: e.type, time }, this);
    },

    onFirstMousemove(e) {
      this.isMainBarOfDrag = true;
      // this method is injected here by GGanttChart.vue, and calls initDrag()
      // for all GGanttBars that belong to the same bundle as this bar:
      this.initDragOfBarsFromBundle(this, e);
    },

    /* ---------------------------------------------------------- */
    /* ------------------- 脱拽实现的方法 ------------------------ */
    /* ---------------------------------------------------------- */
    initDrag(e) {
      // "e" must be the mousedown event
      this.isDragging = true;
      this.barStartBeforeDrag = this.bar[this.barStart];
      this.barEndBeforeDrag = this.bar[this.barEnd];
      let barX = this.$refs["g-gantt-bar"].getBoundingClientRect().left;
      let barY = this.$refs["g-gantt-bar"].getBoundingClientRect().top;
      this.cursorOffsetX = e.clientX - barX;
      this.cursorOffsetY = e.clientY - barY;
      let mousedownType = e.target.className;
      switch (mousedownType) {
        case "g-gantt-bar-handle-left":
          document.body.style.cursor = "w-resize";
          this.mousemoveCallback = this.dragByHandleLeft;
          break;
        case "g-gantt-bar-handle-right":
          document.body.style.cursor = "w-resize";
          this.mousemoveCallback = this.dragByHandleRight;
          break;
        default:
          if (this.bar.status != 30) {
            this.mousemoveCallback = this.drag;
          } else {
            this.mousemoveCallback = null;
          }
      }
      window.addEventListener("mousemove", this.mousemoveCallback);
      window.addEventListener("mouseup", this.endDrag);
    },

    drag(e) {
      let barWidth = this.$refs["g-gantt-bar"].getBoundingClientRect().width;
      //上下吸附处理
      let newXStart = e.clientX - this.barContainer.left - this.cursorOffsetX;
      let y = e.clientY - this.barContainer.top - this.cursorOffsetY;
      let a = -(this.rowN * 40);
      let b = (this.rowcount - this.rowN - 1) * 40;
      if (y <= a) {
        this.newYStart = a;
      } else if (y >= b) {
        this.newYStart = b;
      } else {
        this.newYStart = y;
      }

      let newXEnd = newXStart + barWidth;
      if (this.isPosOutOfDragRange(newXStart, newXEnd)) {
        return;
      }

      this.barStartMoment = this.mapPositionToTime(newXStart);

      this.barEndMoment = this.mapPositionToTime(newXEnd);

      this.manageOverlapping();

      // this.onBarEvent({ event: e, type: 'drag' }, this)
    },

    dragByHandleLeft(e) {
      let newXStart = e.clientX - this.barContainer.left;
      let newStartMoment = this.mapPositionToTime(newXStart);
      if (
        newStartMoment.isSameOrAfter(this.barEndMoment) ||
        this.isPosOutOfDragRange(newXStart, null)
      ) {
        return;
      }
      this.barStartMoment = newStartMoment;
      this.manageOverlapping();
    },

    dragByHandleRight(e) {
      let newXEnd = e.clientX - this.barContainer.left;
      let newEndMoment = this.mapPositionToTime(newXEnd);
      if (
        newEndMoment.isSameOrBefore(this.barStartMoment) ||
        this.isPosOutOfDragRange(null, newXEnd)
      ) {
        return;
      }
      this.barEndMoment = newEndMoment;
      this.manageOverlapping();
    },

    isPosOutOfDragRange(xStart, xEnd) {
      if (!this.ganttChartProps.pushOnOverlap) {
        return false;
      }
      if (
        xStart &&
        this.dragLimitLeft !== null &&
        xStart < this.dragLimitLeft + this.getMinGapBetweenBars()
      ) {
        return true;
      }
      if (
        xEnd &&
        this.dragLimitRight !== null &&
        xEnd > this.dragLimitRight - this.getMinGapBetweenBars()
      ) {
        return true;
      }
      return false;
    },

    endDrag(e) {
      this.isDragging = false;
      this.dragLimitLeft = null;
      this.dragLimitRight = null;
      document.body.style.cursor = "auto";

      if (this.bar.status < 30) {
        const just = new Date(this.barStartMoment).getMinutes() % 5;
        if (just <= 2.5 && just) {
          this.barStartMoment = moment(this.barStartMoment).subtract(
            just,
            "minute"
          );
          this.barEndMoment = moment(this.barEndMoment).subtract(
            just,
            "minute"
          );
        } else if (just > 2.5 && just) {
          this.barStartMoment = moment(this.barStartMoment).add(
            5 - just,
            "minute"
          );
          this.barEndMoment = moment(this.barEndMoment).add(5 - just, "minute");
        }
      }
      window.removeEventListener("mousemove", this.mousemoveCallback);
      window.removeEventListener("mouseup", this.endDrag);
      let num = this.newYStart;
      let row = parseInt(num / 40);
      let yPos = Number(num % 40);
      if (yPos > 20 || yPos < -20) {
        row = row + yPos / Math.abs(yPos);
      }
      if (!row) {
        this.newYStart = row * 40 + 5;
      }
      if (this.isMainBarOfDrag) {
        this.onDragendBar(e, this);
        this.isMainBarOfDrag = false;
      }
    },

    snapBack() {
      this.barStartMoment = this.barStartBeforeDrag;
      this.barEndMoment = this.barEndBeforeDrag;
    },

    manageOverlapping() {
      if (
        !this.ganttChartProps.pushOnOverlap ||
        this.barConfig.pushOnOverlap === false
      ) {
        return;
      }
      let currentBar = this.bar;
      let { overlapBar, overlapType } = this.getOverlapBarAndType(currentBar);
      while (overlapBar) {
        let minuteDiff;
        let currentStartMoment = moment(currentBar[this.barStart]);
        let currentEndMoment = moment(currentBar[this.barEnd]);
        let overlapStartMoment = moment(overlapBar[this.barStart]);
        let overlapEndMoment = moment(overlapBar[this.barEnd]);
        switch (overlapType) {
          case "left":
            minuteDiff =
              overlapEndMoment.diff(currentStartMoment, "minutes", true) +
              this.getMinGapBetweenBars();
            overlapBar[this.barEnd] = currentStartMoment
              .subtract(this.getMinGapBetweenBars(), "minutes", true)
              .format("YYYY-MM-DD HH:mm:ss");
            overlapBar[this.barStart] = overlapStartMoment
              .subtract(minuteDiff, "minutes", true)
              .format("YYYY-MM-DD HH:mm:ss");
            break;
          case "right":
            minuteDiff =
              currentEndMoment.diff(overlapStartMoment, "minutes", true) +
              this.getMinGapBetweenBars();
            overlapBar[this.barStart] = currentEndMoment
              .add(this.getMinGapBetweenBars(), "minutes", true)
              .format("YYYY-MM-DD HH:mm:ss");
            overlapBar[this.barEnd] = overlapEndMoment
              .add(minuteDiff, "minutes", true)
              .format("YYYY-MM-DD HH:mm:ss");
            break;
          default:
            // eslint-disable-next-line
            console.warn(
              "One bar is inside of the other one! This should never occur while push-on-overlap is active!"
            );
            return;
        }
        this.moveBarsFromBundleOfPushedBar(overlapBar, minuteDiff, overlapType);
        currentBar = overlapBar;
        ({ overlapBar, overlapType } = this.getOverlapBarAndType(overlapBar));
      }
    },

    getOverlapBarAndType(bar) {
      let barStartMoment = moment(bar[this.barStart]);
      let barEndMoment = moment(bar[this.barEnd]);
      let overlapLeft, overlapRight, overlapInBetween;
      let overlapBar = this.allBarsInRow.find((otherBar) => {
        if (
          otherBar === bar ||
          otherBar.ganttBarConfig.pushOnOverlap === false
        ) {
          return false;
        }
        let otherBarStart = moment(otherBar[this.barStart]);
        let otherBarEnd = moment(otherBar[this.barEnd]);
        overlapLeft = barStartMoment.isBetween(otherBarStart, otherBarEnd);
        overlapRight = barEndMoment.isBetween(otherBarStart, otherBarEnd);
        overlapInBetween =
          otherBarStart.isBetween(barStartMoment, barEndMoment) ||
          otherBarEnd.isBetween(barStartMoment, barEndMoment);
        return overlapLeft || overlapRight || overlapInBetween;
      });
      let overlapType = overlapLeft
        ? "left"
        : overlapRight
        ? "right"
        : overlapInBetween
        ? "between"
        : null;
      return { overlapBar, overlapType };
    },

    // this is used in GGanttChart, when a bar from a bundle is pushed
    // so that bars from its bundle also get pushed
    moveBarByMinutesAndPush(minuteCount, direction) {
      switch (direction) {
        case "left":
          this.barStartMoment = moment(this.barStartMoment).subtract(
            minuteCount,
            "minutes",
            true
          );
          this.barEndMoment = moment(this.barEndMoment).subtract(
            minuteCount,
            "minutes",
            true
          );
          break;
        case "right":
          this.barStartMoment = moment(this.barStartMoment).add(
            minuteCount,
            "minutes",
            true
          );
          this.barEndMoment = moment(this.barEndMoment).add(
            minuteCount,
            "minutes",
            true
          );
          break;
        default:
          console.warn("wrong direction in moveBarByMinutesAndPush");
          return;
      }
      this.manageOverlapping();
    },

    /* --------------------------------------------------------- */
    /* ------- MAPPING POSITION TO TIME (AND VICE VERSA) ------- */
    /* --------------------------------------------------------- */
    mapTimeToPosition(time) {
      let hourDiffFromStart = moment(time).diff(
        this.chartStartMoment,
        "hour",
        true
      );
      return (
        (hourDiffFromStart / this.getHourCount()) * this.barContainer.width
      );
    },

    mapPositionToTime(xPos) {
      let hourDiffFromStart =
        (xPos / this.barContainer.width) * this.getHourCount();
      return this.chartStartMoment.clone().add(hourDiffFromStart, "hour");
    },
  },

  filters: {
    TimeFilter(value) {
      return moment(value).format("MM/DD HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.process {
  border-bottom: 1px solid #e0e3ea;
}

.d-title {
  white-space: nowrap;
}

.tag {
  text-align: center;
  height: 20px;
  line-height: 20px;
  color: #997bec;
  padding: 0px 2px;
  border-radius: 2px;
  border: 1px solid #997bec;
}

.g-gantt-bar {
  position: absolute;
  margin-top: -1px;
  top: 5px;
  left: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  // color: #000;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  opacity: 0.8;
  overflow: visible;
  width: 300px;
  height: 28px;
  border-radius: 15px;
}

.g-gantt-bar-label {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 14px 0 14px;
  /* 14px is the width of the handle */
  display: flex;
  align-items: center;
}

.g-gantt-bar-label > .show-label {
  // color: #000;
  z-index: 4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.g-gantt-bar > .g-gantt-bar-handle-left,
.g-gantt-bar > .g-gantt-bar-handle-right {
  position: absolute;
  width: 5px;
  height: 100%;
  background: transparent;
  opacity: 1;
  border-radius: 40px;
  z-index: 10;
  cursor: w-resize;
}

.g-gantt-bar-handle-left {
  left: 0;
}

.g-gantt-bar-handle-right {
  right: 0;
}

.g-gantt-bar-label img {
  pointer-events: none;
}

.highlight {
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  background: linear-gradient(90deg, black 50%, transparent 50%),
    linear-gradient(90deg, black 50%, transparent 50%),
    linear-gradient(0deg, black 50%, transparent 50%),
    linear-gradient(0deg, black 50%, transparent 50%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 16px 2px, 16px 2px, 2px 16px, 2px 16px;
  background-position: 0% 0%, 100% 100%, 0% 100%, 100% 0px;
  animation: dash 5s linear infinite;
  z-index: 3;
}

@keyframes dash {
  to {
    background-position: 100% 0%, 0% 100%, 0% 800%, 100% 100%;
  }
}

// .highlight {
// 	&::before,
// 	&::after {
// 		content: "";
// 		position: absolute;
// 		left: -2px;
// 		top: -2px;
// 		background: linear-gradient(
// 			45deg,
// 			#fb0094,
// 			#0000ff,
// 			#00ff00,
// 			#ffff00,
// 			#ff0000,
// 			#fb0094,
// 			#0000ff,
// 			#00ff00,
// 			#ffff00,
// 			#ff0000
// 		);
// 		background-size: 400%;
// 		width: calc(100% + 4px);
// 		height: calc(100% + 4px);
// 		z-index: -1;
// 		animation: steam 20s linear infinite;
// 	}
// }
// @keyframes steam {
// 	0% {
// 		background-position: 0 0;
// 	}
// 	50% {
// 		background-position: 400% 0;
// 	}
// 	100% {
// 		background-position: 0 0;
// 	}
// }

.block:after {
  filter: blur(50px);
}

// .highlight {
// 	&::before {
// 		content: "";
// 		position: absolute;
// 		top: 0;
// 		left: 0;
// 		right: 0;
// 		bottom: 0;
// 		border-radius: 15px;
// 		border: 2px solid rgb(255, 51, 0);
// 		transition: all 0.5s;
// 		animation: clippath 3s infinite linear;
// 	}
// }

// @keyframes clippath {
// 	0%,
// 	100% {
// 		clip-path: inset(0 0 95% 0);
// 	}

// 	25% {
// 		clip-path: inset(0 95% 0 0);
// 	}
// 	50% {
// 		clip-path: inset(95% 0 0 0);
// 	}
// 	75% {
// 		clip-path: inset(0 0 0 95%);
// 	}
// }

.gantt-bar-inner {
  height: 24px;
  left: 2px;
}

.g-gantt-tooltip > .color-indicator {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin-right: 4px;
}
</style>
